import React from "react";
import Head from "next/head";
import Image from "next/image";
import NextLink from "next/link";

import Navbar from "../../../components/navbar";
import Footer from "../../../components/footer";
import Toast from "../../../components/toastnotification";
import BlogGraphic from "../../../public/blog_graphics/face_shape_graphic.png";
import CtaGraphic from "../../../public/blog_graphics/face_shape_cta.png";

const BlogPage = () => {
  function scrollFunction() {
    if (
      document.body.scrollTop > 20 ||
      document.documentElement.scrollTop > 20
    ) {
      document.getElementById("scroll-top-button").style.display = "flex";
    } else {
      document.getElementById("scroll-top-button").style.display = "none";
    }
  }
  if (typeof window !== "undefined") {
    window.onscroll = function() {
      scrollFunction();
    };
  }
  return (
    <>
      <Head>
        <title>The Easiest Method to Identify Your Face Shape | StyleSense Blog</title>
        <meta
          name="description"
          content="Learn how to identify your face shape with our free AI Face Analyzer. Simply take or upload a selfie to get started!"
          key="desc"
        />
      </Head>
    <main className="min-h-screen flex flex-col justify-between items-center">
      <Navbar />
      <section class="py-10 sm:py-14 lg:py-18">
        <div class="px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl">
        <div className="mb-4 text-sm breadcrumbs">
              <ul>
                <li><NextLink href="/">Home</NextLink></li> 
                <li><NextLink href="/blog">Blog</NextLink></li> 
                <li>How to Identify Your Face Shape?</li>
              </ul>
            </div>           
          <div class="max-w-5xl mx-auto">
            <div class="max-w-4xl">             
              <h1
                id="blog-title"
                class="text-4xl font-bold text-indigo-900 dark:text-white sm:text-5xl"
              >
                How to Identify Your Face Shape? <br />
                <span className="text-3xl">
                  Understanding Different Facial Features
                </span>
              </h1>{" "}
              <p class="mt-6 text-base font-medium text-rose-500">
                August 12, 2023
              </p>
            </div>{" "}
            <div class="mt-12 sm:mt-16 lg:grid lg:grid-cols-12 lg:gap-x-16 xl:gap-x-24">
              <aside class="lg:col-span-4 lg:order-last lg:self-start lg:sticky lg:top-32">
                <div class="overflow-hidden bg-white border border-gray-200">
                  <div
                    itemscope="itemscope"
                    itemtype="https://schema.org/TableOfContents"
                    class="px-4 py-5 sm:p-6"
                  >
                    <h4 class="text-xs font-bold tracking-widest text-gray-400 uppercase">
                      Table of Contents:
                    </h4>{" "}
                    <ul class="mt-6 space-y-5">
                      <li>
                        <NextLink
                          href="/blog/understanding-different-face-shapes#oval-face-shape"
                          class="flex text-base font-bold text-gray-500 hover:underline"
                          itemprop="associatedMedia"
                          title=""
                        >
                          Oval Face Shape
                        </NextLink>
                      </li>
                      <li>
                        <NextLink
                          href="/blog/understanding-different-face-shapes#rectangle-face-shape"
                          class="flex text-base font-bold text-gray-500 hover:underline"
                          itemprop="associatedMedia"
                          title=""
                        >
                          Rectangle Face Shape
                        </NextLink>
                      </li>
                      <li>
                        <NextLink
                          href="/blog/understanding-different-face-shapes#heart-face-shape"
                          class="flex text-base font-bold text-gray-500 hover:underline"
                          itemprop="associatedMedia"
                          title=""
                        >
                          Heart Face Shape
                        </NextLink>
                      </li>
                      <li>
                        <NextLink
                          href="/blog/understanding-different-face-shapes#diamond-face-shape"
                          class="flex text-base font-bold text-gray-500 hover:underline"
                          itemprop="associatedMedia"
                          title=""
                        >
                          Diamond Face Shape
                        </NextLink>
                      </li>
                      <li>
                        <NextLink
                          href="/blog/understanding-different-face-shapes#pear-face-shape"
                          class="flex text-base font-bold text-gray-500 hover:underline"
                          itemprop="associatedMedia"
                          title=""
                        >
                          Pear Face Shape
                        </NextLink>
                      </li>
                      <li>
                        <NextLink
                          href="/blog/understanding-different-face-shapes#square-face-shape"
                          class="flex text-base font-bold text-gray-500 hover:underline"
                          itemprop="associatedMedia"
                          title=""
                        >
                          Square Face Shape
                        </NextLink>
                      </li>
                      <li>
                        <NextLink
                          href="/blog/understanding-different-face-shapes#round-face-shape"
                          class="flex text-base font-bold text-gray-500 hover:underline"
                          itemprop="associatedMedia"
                          title=""
                        >
                          Round Face Shape
                        </NextLink>
                      </li>
                      <li>
                        <NextLink
                          href="/blog/understanding-different-face-shapes#conclusion"
                          class="flex text-base font-bold text-gray-500 hover:underline"
                          itemprop="associatedMedia"
                          title=""
                        >
                          Conclusion
                        </NextLink>
                      </li>
                    </ul>
                  </div>
                </div>
              </aside>{" "}
              <NextLink
                href="/blog/understanding-different-face-shapes#navbar"
                id="scroll-top-button"
                class="hidden fixed bottom-0 right-0 z-50 flex items-center justify-center w-12 h-12 mb-4 mr-4 text-white bg-gray-800 rounded-full shadow-lg cursor-pointer hover:bg-gray-700"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4.5 10.5L12 3m0 0l7.5 7.5M12 3v18"
                  />
                </svg>
              </NextLink>
              <div class="lg:col-span-8 mt-8 lg:mt-0">
                {/* <img src="/blog_graphics/face_shape_graphic.png" />{" "} */}
                <Image src={BlogGraphic} alt="" />{" "}
                <article class="mt-8 prose lg:prose-lg prose-blockquote:lg:text-xl prose-blockquote:lg:leading-9 prose-blockquote:not-italic prose-blockquote:border-none prose-blockquote:text-lg prose-blockquote:leading-8 prose-blockquote:p-0 prose-blockquote:lg:p-0 prose-blockquote:font-medium text-gray-900 dark:text-gray-200">
                  <p>
                    Your face shape is determined by the bone structure of your
                    face, and it can have a significant impact on your overall
                    appearance. There are seven main face shapes: oval,
                    rectangle, heart, diamond, pear, square, and round. Each of
                    these shapes has unique features that can help you identify
                    your face shape.
                  </p>
                  <Toast page={"face_shape_blog"} full={true} />
                  <h2 id="oval-face-shape">
                    <strong>Oval Face Shape</strong>
                  </h2>
                  <div className="float-right mr-5 not-prose my-[-5px]">
                    <Image
                      src="/jimin_park.jpg"
                      alt="Jimin"
                      width={150}
                      height={200}
                    />
                    <p className="text-sm">
                      Jimin{" "}
                      <a
                        className="link"
                        href="https://commons.wikimedia.org/wiki/File:Park_Jimin_at_MAMA_in_Hong_Kong,_3_December_2014_03.jpg"
                      >
                        (Source)
                      </a>
                    </p>
                  </div>
                  <p>
                    If your face is longer than it is wide, and your forehead
                    and cheekbones have a similar width, you likely have an oval
                    face shape. Your jawline may be slightly narrow, and your
                    chin is rounded. People with oval face shapes typically have
                    prominent cheekbones and a fuller face. Oval faces are
                    considered the most versatile face shape and can pull off
                    various hairstyles and makeup looks.
                  </p>
                  <h2 id="rectangle-face-shape">
                    <strong>Rectangle Face Shape</strong>
                  </h2>
                  <div className="float-right mr-5 not-prose my-[-5px]">
                    <Image
                      src="/olivia_wilde.jpg"
                      alt="Olivia Wilde"
                      width={150}
                      height={200}
                    />
                    <p className="text-sm">
                      Olivia Wilde{" "}
                      <a
                        className="link"
                        href="https://commons.wikimedia.org/wiki/File:Olivia_Wilde_in_2010_Independent_Spirit_Awards.jpg"
                      >
                        (Source)
                      </a>
                    </p>
                  </div>
                  <p>
                    A rectangle face shape is also longer than it is wide, with
                    a similar width between the forehead and cheekbones.
                    However, the jawline is slightly wider, and the chin is
                    square. People with rectangle face shapes may have a square
                    jawline and a slimmer face, making them look great with long
                    hairstyles.
                  </p>
                  <h2 id="heart-face-shape">
                    <strong>Heart Face Shape</strong>
                  </h2>
                  <div className="float-left mr-5 not-prose my-[-5px]">
                    <Image
                      src="/AnnaSophia_Robb.jpg"
                      alt="AnnaSophia Robb"
                      width={150}
                      height={200}
                    />
                    <p className="text-sm">
                      AnnaSophia Robb{" "}
                      <a
                        className="link"
                        href="https://disney.fandom.com/wiki/AnnaSophia_Robb"
                      >
                        (Source)
                      </a>
                    </p>
                  </div>
                  <p>
                    A heart-shaped face is characterized by a wider forehead and
                    prominent cheekbones, with an angular jawline and a pointy
                    chin. People with heart-shaped faces often have
                    proportionate face length, and their features can be
                    accentuated with hairstyles that add volume around the chin
                    area.
                  </p>
                  <h2 id="diamond-face-shape">
                    <strong>Diamond Face Shape</strong>
                  </h2>
                  <div className="float-left mr-5 not-prose my-[-5px]">
                    <Image
                      src="/yeeun.png"
                      alt="Jang Ye-eun"
                      width={150}
                      height={200}
                    />
                    <p className="text-sm">
                      Jang Ye-eun
                      <a
                        className="link"
                        href="https://commons.wikimedia.org/wiki/File:Yeeun_at_No.1_fansign_on_February_10,_2019.png"
                      >
                        (Source)
                      </a>
                    </p>
                  </div>
                  <p>
                    Diamond face shapes are defined by prominent cheekbones that
                    are wider than the forehead and the chin. The forehead is
                    typically narrower, and the jawline is angular with a pointy
                    chin. People with diamond faces can opt for hairstyles that
                    emphasize their cheekbones while softening their chin.
                  </p>
                  <h2 id="pear-face-shape">
                    <strong>Pear Face Shape</strong>
                  </h2>
                  <div className="float-right mr-5 not-prose my-[-5px]">
                    <Image
                      src="/Amber_Riley.jpeg"
                      alt="Amber Riley"
                      width={150}
                      height={200}
                    />
                    <p className="text-sm">
                      Amber Riley
                      <a
                        className="link"
                        href="https://commons.wikimedia.org/wiki/File:Amber_Riley_by_Gage_Skidmore.jpg"
                      >
                        (Source)
                      </a>
                    </p>
                  </div>
                  <p>
                    If your jaw is wider than your forehead and your cheekbones
                    are no wider than your chin, you may have a pear-shaped
                    face. People with pear-shaped faces have a square jawline
                    and a square chin. To balance their features, they can go
                    for hairstyles that add volume to the forehead and temples.
                  </p>
                  <h2 id="square-face-shape">
                    <strong>Square Face Shape</strong>
                  </h2>
                  <div className="float-left mr-5 not-prose my-[-5px]">
                    <Image
                      src="/Daniel_Radcliffe.jpeg"
                      alt="Daniel Radcliffe"
                      width={150}
                      height={200}
                    />
                    <p className="text-sm">
                      Daniel Radcliffe
                      <a
                        className="link"
                        href="https://commons.wikimedia.org/wiki/File:Daniel_Radcliffe_2014.jpg"
                      >
                        (Source)
                      </a>
                    </p>
                  </div>
                  <p>
                    A square face shape has roughly equal length and width, with
                    similar forehead and cheekbone width. The jawline is
                    slightly wider, and the chin is square. People with square
                    faces may also have a square jawline and a slimmer face.
                    Hairstyles that soften the jawline and add volume to the top
                    of the head are ideal for square faces.
                  </p>
                  <h2 id="round-face-shape">
                    <strong>Round Face Shape</strong>
                  </h2>
                  <div className="float-right mr-5 not-prose my-[-5px]">
                    <Image
                      src="/karen_gillan.jpeg"
                      alt="Karen Gillan"
                      width={150}
                      height={200}
                    />
                    <p className="text-sm">
                      Karen Gillan
                      <a
                        className="link"
                        href="https://commons.wikimedia.org/wiki/File:Karen_Gillan_%2834833524262%29_%28cropped%29.jpg"
                      >
                        (Source)
                      </a>
                    </p>
                  </div>
                  <p>
                    If your face has roughly equal length and width, with
                    similar forehead and cheekbone width, and your jawline is
                    slightly narrow, you may have a round face shape. People
                    with round faces also have a rounded chin and prominent
                    cheekbones. Hairstyles that add volume to the crown and
                    create angles around the jawline can help elongate the face.
                  </p>
                  <h2 id="conclusion">
                    <strong>Conclusion</strong>
                  </h2>
                  <p>
                    Knowing your face shape can help you select hairstyles,
                    makeup looks, and even glasses that flatter your features.
                    By understanding the unique characteristics of each face
                    shape, you can choose styles that enhance your natural
                    beauty and highlight your best features. Whether you have an
                    oval, rectangle, heart, diamond, pear, square, or round face
                    shape, embrace your unique features and choose styles that
                    make you feel confident and beautiful.
                  </p>
                </article>
              </div>
            </div>
            <section class="mx-auto max-w-7xl mt-8">
              <div class="mx-auto flex max-w-3xl flex-col gap-10 bg-rainbow dark:bg-rainbowdark px-6 py-8 ring-1 ring-white/10 sm:rounded-3xl sm:p-6 lg:mx-0 lg:max-w-none lg:flex-row lg:items-center lg:py-10 xl:gap-x-10 xl:px-16">
                <Image
                  src={CtaGraphic}
                  alt=""
                  class="h-96 w-full flex-none rounded-2xl object-cover shadow-xl lg:aspect-square lg:h-auto lg:max-w-sm v-lazy-image v-lazy-image-loaded"
                  srcset="/blog_graphics/face_shape_cta.png 1x, /blog_graphics/face_shape_cta.png 2x"
                />
                <div class="w-full flex-auto">
                  <h4 class="text-3xl font-bold text-white sm:text-4xl">
                    Know your face shape today
                  </h4>{" "}
                  <p class="mt-5 text-base font-normal text-white/80">
                    Try our free <NextLink href="/face_analyzer">AI Face Analyzer</NextLink> today — simply take or upload a selfie to identify your face shape, along with details about your facial features. Unlock the secrets to looking your best!
                  </p>{" "}
                  <ul
                    role="list"
                    class="mt-10 grid grid-cols-1 gap-x-8 gap-y-3 text-base leading-7 text-white sm:grid-cols-2"
                  >
                    <li class="flex gap-x-3">
                      <svg
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                        class="h-7 w-5 flex-none text-indigo-900"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                      Instantly get results
                    </li>{" "}
                    <li class="flex gap-x-3">
                      <svg
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                        class="h-7 w-5 flex-none text-indigo-900"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                      Free forever
                    </li>{" "}
                    <li class="flex gap-x-3">
                      <svg
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                        class="h-7 w-5 flex-none text-indigo-900"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                      No data stored
                    </li>{" "}
                    <li class="flex gap-x-3">
                      <svg
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                        class="h-7 w-5 flex-none text-indigo-900"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                      No sign up required
                    </li>
                  </ul>{" "}
                  <div class="mt-10 flex flex-col md:flex-row space-x-6 space-y-2 md:space-y-0">
                    <NextLink href="/face_analyzer" class="w-full md:w-auto">
                      <button
                        aria-label="Primary Button"
                        type="button"
                        class="hover:bg-indigo-800 focus:ring-indigo-200 flex flex-shrink-0 content-center items-center justify-center rounded-md border border-transparent bg-indigo-500 px-6 py-3 text-center text-base font-medium text-white shadow-sm transition duration-100 focus:outline-none focus:ring-2 focus:ring-offset-2 w-full md:w-auto"
                      >
                        Get your Face Shape
                      </button>
                    </NextLink>{" "}
                    <div class="hidden md:flex items-center justify-center gap-3 lg:justify-start">
                      <div class="flex">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          class="h-5 w-5 text-yellow-400"
                        >
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                        </svg>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          class="h-5 w-5 text-yellow-400"
                        >
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                        </svg>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          class="h-5 w-5 text-yellow-400"
                        >
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                        </svg>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          class="h-5 w-5 text-yellow-400"
                        >
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                        </svg>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          class="h-5 w-5 text-yellow-400"
                        >
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>

      <Footer />
    </main>
    </>
  );
};

export default BlogPage;

// const BlogPage = () => {
//   // Your component's rendering logic here
//   // You can include JSX elements, components, and any other React logic.
//   return (
//     <div>
//       <h1>Welcome to the Blog Page</h1>
//       <p>This is where your blog content will be displayed.</p>
//     </div>
//   );
// }

// export default BlogPage;
